import { render, staticRenderFns } from "./PreviewReceivedCard.vue?vue&type=template&id=5a7c24af&scoped=true&"
import script from "./PreviewReceivedCard.vue?vue&type=script&lang=js&"
export * from "./PreviewReceivedCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewReceivedCard.vue?vue&type=style&index=0&id=5a7c24af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c24af",
  null
  
)

export default component.exports